/**
 * @description 租赁中心
 * @param {}
 * @returns {}
*/
import React, { useEffect, useMemo, useState,useRef } from "react";
import styles from "./styles.module.scss";
import { ScoreXBtn } from "../components/button";
import close from '@/assets/img/landfi/icon_del.png';
import LandLease from "./landLease";
import ApeLease from "./apeLease";
import MyLeaseOut from "./myLeaseOut";
import MyLease from "./myLease";
import RendOut from "./rentOut"
import GemDetail from "./rentOut/gemDetail"
import { getGemstoreCount } from '@/api/guland'
import OtherLease from "@/view/landGame/leaseCenter/otherLease";

const LeaseCenter = () => {
  const [currentTab, setCurrentTab] = useState(0);
  const [rendOutVisible, setRendOutVisible] = useState(false)
  const [gemDetailVisible, setGemDetailVisible] = useState(false)
  const [gemstoreCounts, setGemstoreCounts] = useState(0)
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);
  const needRotate = params.get('needRotate') === 'true' // 从我的数字藏品页面过来的需要翻转屏幕

  const pageRef = useRef(null)

  useEffect(() => {
    queryGemstoreCounts()
    window.JsBridgeNew.addKeyboardEvent()
    if (needRotate) {
      window.JsBridgeNew.hiddenStatusBar(true)
      window.JsBridgeNew.screenRotate(false);
    }
  }, [])

  const TabConentMap = useMemo(() => {
    return {
      0: <LandLease />,
      1: <ApeLease />,
      2: <MyLeaseOut />,
      3: <MyLease />,
      4: <OtherLease />,
    }
  }, [])

  const queryGemstoreCounts = async () => {
    try {
      const res = await getGemstoreCount()
      if (res?.code !== '000000') throw res?.msg
      setGemstoreCounts(res?.data?.gemstonesCount || 0)
    } catch (error) {
      console.log(error)
    }
  }

  return <div className={styles.land_lease_center} ref={pageRef}>
    <ScoreXBtn style={{top: '2vw', right: '13vw'}} gemCount={gemstoreCounts} onClick={() => setGemDetailVisible(true)}/>
    <img 
      className={styles.close} 
      src={close} 
      alt="" 
      onClick={() => {
        if (window.JsBridge.hasWebViewBridge()) {
          window.JsBridge.back();
        } else {
          window.history.go(-1);
        }
        if(needRotate){
          window.JsBridgeNew.hiddenStatusBar(false);
          window.JsBridgeNew.screenRotate(true);
        }
      }}
    />
    <div className={styles.left_tabs}>
      <div className={styles.tabs_title}>租赁中心</div>
      <div className={styles.tabs_top}>
        <div className={`${styles.tabs_item} ${currentTab === 0 ? styles.active: ''}`} onClick={() => setCurrentTab(0)}>土地</div>
        <div className={`${styles.tabs_item} ${currentTab === 1 ? styles.active: ''}`} onClick={() => setCurrentTab(1)}>无聊猿</div>
        <div className={`${styles.tabs_item} ${currentTab === 4 ? styles.active: ''}`} onClick={() => setCurrentTab(4)}>其他</div>
      </div>
      <div className={styles.tabs_bottom}>
        <div>
          <div className={`${styles.tabs_item} ${currentTab === 2 ? styles.active: ''}`} onClick={() => setCurrentTab(2)}>我出租的</div>
          <div className={`${styles.tabs_item} ${currentTab === 3 ? styles.active: ''}`} onClick={() => setCurrentTab(3)}>我租来的</div>
        </div>
        <div className={styles.tabs_item_last}  onClick={() => setRendOutVisible(true)}></div>
      </div>
    </div>
    <div className={styles.tabs_content}>{TabConentMap[currentTab]}</div>
   {rendOutVisible && <RendOut 
      visible={rendOutVisible} 
      onclose={(refresh) => {
        setRendOutVisible(false)
      }}
      container={pageRef.current}
      />
    }
    {gemDetailVisible && <GemDetail 
      visible={gemDetailVisible} 
      onclose={(refresh) => {
        setGemDetailVisible(false)
      }}
      container={pageRef.current}
      />}
  </div>
}

export default LeaseCenter;